// Countdown Timer
(function() {
  function initCountdown() {
    const timerElement = document.querySelector('.countdown-timer');
    if (!timerElement) return;

    const endDateStr = timerElement.getAttribute('data-end-date');
    if (!endDateStr) return;

    const endDate = new Date(endDateStr).getTime();

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = endDate - now;

      if (distance < 0) {
        // document.getElementById('days').textContent = '00';
        document.getElementById('hours').textContent = '00';
        document.getElementById('minutes').textContent = '00';
        document.getElementById('seconds').textContent = '00';
        return;
      }

      // const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // document.getElementById('days').textContent = String(days).padStart(2, '0');
      document.getElementById('hours').textContent = String(hours).padStart(2, '0');
      document.getElementById('minutes').textContent = String(minutes).padStart(2, '0');
      document.getElementById('seconds').textContent = String(seconds).padStart(2, '0');
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountdown);
  } else {
    initCountdown();
  }
})();

// Slider
function checkSliderOverflow() {
  const sliders = document.querySelectorAll('.limited-time-bundles-section .top-picks-collection-wrapper');

  sliders.forEach((sliderWrapper) => {
    const wrapper = sliderWrapper.querySelector('.top-picks-section__products');
    if (!wrapper) return;

    const prevBtn = sliderWrapper.querySelector('.button-prev');
    const nextBtn = sliderWrapper.querySelector('.button-next');

    // Check if content overflows
    const hasOverflow = wrapper.scrollWidth > wrapper.clientWidth;

    if (prevBtn && nextBtn) {
      if (hasOverflow) {
        prevBtn.style.display = 'flex';
        nextBtn.style.display = 'flex';
      } else {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
      }
    }
  });
}

// Check on load and resize
checkSliderOverflow();
window.addEventListener('resize', checkSliderOverflow);

document.querySelectorAll('.limited-time-bundles-section .slider-button').forEach((button) => {
  button.addEventListener('click', function() {
    const direction = this.dataset.direction;
    const targetId = this.dataset.target;
    const wrapper = document.querySelector(`.${targetId} .top-picks-section__products`);

    if (!wrapper) return;

    const firstCard = wrapper.querySelector('.top-picks-section__product');
    if (!firstCard) return;

    const cardStyle = getComputedStyle(firstCard);
    const cardWidth = firstCard.offsetWidth + parseFloat(cardStyle.marginRight || 0);

    wrapper.scrollBy({
      left: direction === 'next' ? cardWidth : -cardWidth,
      behavior: 'smooth',
    });
  });
});
